// src/services/authService.js
//
// Wraps /api/auth/* backend calls.

import { api } from './api';

export const authService = {
  login: (email, password) =>
    api.post('/api/auth/login', { email, password }),

  verify2FA: (tempToken, otp) =>
    api.post('/api/auth/verify-2fa', { temp_token: tempToken, otp }),

  resend2FA: (tempToken) =>
    api.post('/api/auth/resend-2fa', { temp_token: tempToken }),

  getMe: () =>
    api.get('/api/auth/me'),

  setPasswordViaInvite: (token, password) =>
    api.post('/api/auth/set-password', { token, password }),

  forgotPassword: (email) =>
    api.post('/api/auth/forgot-password', { email }),

  resetPassword: (token, newPassword) =>
    api.post('/api/auth/reset-password', { token, new_password: newPassword }),

  inviteUser: (fullName, email, role) =>
    api.post('/api/auth/invite-user', { full_name: fullName, email: email, role: role }),

  refreshToken: (refreshToken) =>
    api.post('/api/auth/refresh', { refresh_token: refreshToken }, { auth: false }),

  getManagersAndReps: () =>
    api.get('/api/auth/users'),

  deleteUser: (userId) =>
    api.delete('/api/auth/users/' + userId),

  deactivateUser: (userId) =>
    api.put('/api/auth/users/' + userId + '/deactivate', {}),
};